import { jsx as l } from "react/jsx-runtime";
import { useFoundation as d, createComponent as f, mergeRefs as u } from "@rmwc/base";
import { MDCFloatingLabelFoundation as m } from "@material/floating-label";
import { useEffect as s } from "react";
const c = (a) => {
  const { foundation: n, ...o } = d({
    props: a,
    elements: {
      rootEl: !0
    },
    api: ({
      foundation: t
    }) => ({
      getWidth() {
        return t.getWidth();
      },
      setRequired(e) {
        return t.setRequired(e);
      }
    }),
    foundation: ({ rootEl: t }) => new m({
      addClass: (e) => t.addClass(e),
      removeClass: (e) => t.removeClass(e),
      getWidth: () => {
        var e;
        return ((e = t.ref) == null ? void 0 : e.scrollWidth) || 0;
      },
      registerInteractionHandler: (e, r) => t.addEventListener(e, r),
      deregisterInteractionHandler: (e, r) => t.removeEventListener(e, r)
    })
  });
  return s(() => {
    n.shake(!!a.shake);
  }, [a.shake, n]), s(() => {
    n.float(!!a.float);
  }, [a.float, n]), { foundation: n, ...o };
}, b = f(function(n, o) {
  const { rootEl: t } = c(n), { shake: e, float: r, apiRef: g, ...i } = n;
  return /* @__PURE__ */ l(
    "span",
    {
      ...t.props({ ...i, className: "mdc-floating-label" }),
      ref: u(t.reactRef, o)
    }
  );
});
export {
  b as FloatingLabel
};
